/* tslint:disable */
/* eslint-disable */
/**
 * Data Processor
 * NextUp Data processor
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@nextupsoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InputRecordGroupWithChildren } from '../models';
// @ts-ignore
import type { ListInputRecordGroupWithChildrens200Response } from '../models';
// @ts-ignore
import type { PartialInputRecordGroupWithChildren } from '../models';
/**
 * InputRecordGroupsApi - axios parameter creator
 */
export const InputRecordGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {InputRecordGroupWithChildren} [inputRecordGroupWithChildren] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInputRecordGroupWithChildren: async (inputRecordGroupWithChildren?: InputRecordGroupWithChildren, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/input_record_groups/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputRecordGroupWithChildren, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyInputRecordGroupWithChildren: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyInputRecordGroupWithChildren', 'id', id)
            const localVarPath = `/api/input_record_groups/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadInputRecordGroupWithChildren: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadInputRecordGroupWithChildren', 'id', id)
            const localVarPath = `/api/input_record_groups/{id}/download/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInputRecordGroupWithChildrens: async (page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/input_record_groups/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PartialInputRecordGroupWithChildren} [partialInputRecordGroupWithChildren] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateInputRecordGroupWithChildren: async (id: string, partialInputRecordGroupWithChildren?: PartialInputRecordGroupWithChildren, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partialUpdateInputRecordGroupWithChildren', 'id', id)
            const localVarPath = `/api/input_record_groups/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partialInputRecordGroupWithChildren, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveInputRecordGroupWithChildren: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveInputRecordGroupWithChildren', 'id', id)
            const localVarPath = `/api/input_record_groups/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retry the export of the tms order.
         * @param {string} id 
         * @param {InputRecordGroupWithChildren} [inputRecordGroupWithChildren] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryInputRecordGroupWithChildren: async (id: string, inputRecordGroupWithChildren?: InputRecordGroupWithChildren, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retryInputRecordGroupWithChildren', 'id', id)
            const localVarPath = `/api/input_record_groups/{id}/retry/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputRecordGroupWithChildren, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {InputRecordGroupWithChildren} [inputRecordGroupWithChildren] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInputRecordGroupWithChildren: async (id: string, inputRecordGroupWithChildren?: InputRecordGroupWithChildren, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateInputRecordGroupWithChildren', 'id', id)
            const localVarPath = `/api/input_record_groups/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputRecordGroupWithChildren, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InputRecordGroupsApi - functional programming interface
 */
export const InputRecordGroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InputRecordGroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {InputRecordGroupWithChildren} [inputRecordGroupWithChildren] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInputRecordGroupWithChildren(inputRecordGroupWithChildren?: InputRecordGroupWithChildren, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputRecordGroupWithChildren>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInputRecordGroupWithChildren(inputRecordGroupWithChildren, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InputRecordGroupsApi.createInputRecordGroupWithChildren']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyInputRecordGroupWithChildren(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyInputRecordGroupWithChildren(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InputRecordGroupsApi.destroyInputRecordGroupWithChildren']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadInputRecordGroupWithChildren(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputRecordGroupWithChildren>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadInputRecordGroupWithChildren(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InputRecordGroupsApi.downloadInputRecordGroupWithChildren']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInputRecordGroupWithChildrens(page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListInputRecordGroupWithChildrens200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInputRecordGroupWithChildrens(page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InputRecordGroupsApi.listInputRecordGroupWithChildrens']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {PartialInputRecordGroupWithChildren} [partialInputRecordGroupWithChildren] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partialUpdateInputRecordGroupWithChildren(id: string, partialInputRecordGroupWithChildren?: PartialInputRecordGroupWithChildren, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartialInputRecordGroupWithChildren>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partialUpdateInputRecordGroupWithChildren(id, partialInputRecordGroupWithChildren, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InputRecordGroupsApi.partialUpdateInputRecordGroupWithChildren']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveInputRecordGroupWithChildren(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputRecordGroupWithChildren>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveInputRecordGroupWithChildren(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InputRecordGroupsApi.retrieveInputRecordGroupWithChildren']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retry the export of the tms order.
         * @param {string} id 
         * @param {InputRecordGroupWithChildren} [inputRecordGroupWithChildren] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryInputRecordGroupWithChildren(id: string, inputRecordGroupWithChildren?: InputRecordGroupWithChildren, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputRecordGroupWithChildren>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryInputRecordGroupWithChildren(id, inputRecordGroupWithChildren, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InputRecordGroupsApi.retryInputRecordGroupWithChildren']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {InputRecordGroupWithChildren} [inputRecordGroupWithChildren] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInputRecordGroupWithChildren(id: string, inputRecordGroupWithChildren?: InputRecordGroupWithChildren, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputRecordGroupWithChildren>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInputRecordGroupWithChildren(id, inputRecordGroupWithChildren, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InputRecordGroupsApi.updateInputRecordGroupWithChildren']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InputRecordGroupsApi - factory interface
 */
export const InputRecordGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InputRecordGroupsApiFp(configuration)
    return {
        /**
         * 
         * @param {InputRecordGroupsApiCreateInputRecordGroupWithChildrenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInputRecordGroupWithChildren(requestParameters: InputRecordGroupsApiCreateInputRecordGroupWithChildrenRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<InputRecordGroupWithChildren> {
            return localVarFp.createInputRecordGroupWithChildren(requestParameters.inputRecordGroupWithChildren, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InputRecordGroupsApiDestroyInputRecordGroupWithChildrenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyInputRecordGroupWithChildren(requestParameters: InputRecordGroupsApiDestroyInputRecordGroupWithChildrenRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.destroyInputRecordGroupWithChildren(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InputRecordGroupsApiDownloadInputRecordGroupWithChildrenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadInputRecordGroupWithChildren(requestParameters: InputRecordGroupsApiDownloadInputRecordGroupWithChildrenRequest, options?: RawAxiosRequestConfig): AxiosPromise<InputRecordGroupWithChildren> {
            return localVarFp.downloadInputRecordGroupWithChildren(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InputRecordGroupsApiListInputRecordGroupWithChildrensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInputRecordGroupWithChildrens(requestParameters: InputRecordGroupsApiListInputRecordGroupWithChildrensRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListInputRecordGroupWithChildrens200Response> {
            return localVarFp.listInputRecordGroupWithChildrens(requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InputRecordGroupsApiPartialUpdateInputRecordGroupWithChildrenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateInputRecordGroupWithChildren(requestParameters: InputRecordGroupsApiPartialUpdateInputRecordGroupWithChildrenRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartialInputRecordGroupWithChildren> {
            return localVarFp.partialUpdateInputRecordGroupWithChildren(requestParameters.id, requestParameters.partialInputRecordGroupWithChildren, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InputRecordGroupsApiRetrieveInputRecordGroupWithChildrenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveInputRecordGroupWithChildren(requestParameters: InputRecordGroupsApiRetrieveInputRecordGroupWithChildrenRequest, options?: RawAxiosRequestConfig): AxiosPromise<InputRecordGroupWithChildren> {
            return localVarFp.retrieveInputRecordGroupWithChildren(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retry the export of the tms order.
         * @param {InputRecordGroupsApiRetryInputRecordGroupWithChildrenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryInputRecordGroupWithChildren(requestParameters: InputRecordGroupsApiRetryInputRecordGroupWithChildrenRequest, options?: RawAxiosRequestConfig): AxiosPromise<InputRecordGroupWithChildren> {
            return localVarFp.retryInputRecordGroupWithChildren(requestParameters.id, requestParameters.inputRecordGroupWithChildren, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InputRecordGroupsApiUpdateInputRecordGroupWithChildrenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInputRecordGroupWithChildren(requestParameters: InputRecordGroupsApiUpdateInputRecordGroupWithChildrenRequest, options?: RawAxiosRequestConfig): AxiosPromise<InputRecordGroupWithChildren> {
            return localVarFp.updateInputRecordGroupWithChildren(requestParameters.id, requestParameters.inputRecordGroupWithChildren, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createInputRecordGroupWithChildren operation in InputRecordGroupsApi.
 */
export interface InputRecordGroupsApiCreateInputRecordGroupWithChildrenRequest {
    readonly inputRecordGroupWithChildren?: InputRecordGroupWithChildren
}

/**
 * Request parameters for destroyInputRecordGroupWithChildren operation in InputRecordGroupsApi.
 */
export interface InputRecordGroupsApiDestroyInputRecordGroupWithChildrenRequest {
    /**
     * 
     */
    readonly id: string
}

/**
 * Request parameters for downloadInputRecordGroupWithChildren operation in InputRecordGroupsApi.
 */
export interface InputRecordGroupsApiDownloadInputRecordGroupWithChildrenRequest {
    /**
     * 
     */
    readonly id: string
}

/**
 * Request parameters for listInputRecordGroupWithChildrens operation in InputRecordGroupsApi.
 */
export interface InputRecordGroupsApiListInputRecordGroupWithChildrensRequest {
    /**
     * A page number within the paginated result set.
     */
    readonly page?: number
}

/**
 * Request parameters for partialUpdateInputRecordGroupWithChildren operation in InputRecordGroupsApi.
 */
export interface InputRecordGroupsApiPartialUpdateInputRecordGroupWithChildrenRequest {
    /**
     * 
     */
    readonly id: string

    readonly partialInputRecordGroupWithChildren?: PartialInputRecordGroupWithChildren
}

/**
 * Request parameters for retrieveInputRecordGroupWithChildren operation in InputRecordGroupsApi.
 */
export interface InputRecordGroupsApiRetrieveInputRecordGroupWithChildrenRequest {
    /**
     * 
     */
    readonly id: string
}

/**
 * Request parameters for retryInputRecordGroupWithChildren operation in InputRecordGroupsApi.
 */
export interface InputRecordGroupsApiRetryInputRecordGroupWithChildrenRequest {
    /**
     * 
     */
    readonly id: string

    readonly inputRecordGroupWithChildren?: InputRecordGroupWithChildren
}

/**
 * Request parameters for updateInputRecordGroupWithChildren operation in InputRecordGroupsApi.
 */
export interface InputRecordGroupsApiUpdateInputRecordGroupWithChildrenRequest {
    /**
     * 
     */
    readonly id: string

    readonly inputRecordGroupWithChildren?: InputRecordGroupWithChildren
}

/**
 * InputRecordGroupsApi - object-oriented interface
 */
export class InputRecordGroupsApi extends BaseAPI {
    /**
     * 
     * @param {InputRecordGroupsApiCreateInputRecordGroupWithChildrenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createInputRecordGroupWithChildren(requestParameters: InputRecordGroupsApiCreateInputRecordGroupWithChildrenRequest = {}, options?: RawAxiosRequestConfig) {
        return InputRecordGroupsApiFp(this.configuration).createInputRecordGroupWithChildren(requestParameters.inputRecordGroupWithChildren, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InputRecordGroupsApiDestroyInputRecordGroupWithChildrenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public destroyInputRecordGroupWithChildren(requestParameters: InputRecordGroupsApiDestroyInputRecordGroupWithChildrenRequest, options?: RawAxiosRequestConfig) {
        return InputRecordGroupsApiFp(this.configuration).destroyInputRecordGroupWithChildren(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InputRecordGroupsApiDownloadInputRecordGroupWithChildrenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadInputRecordGroupWithChildren(requestParameters: InputRecordGroupsApiDownloadInputRecordGroupWithChildrenRequest, options?: RawAxiosRequestConfig) {
        return InputRecordGroupsApiFp(this.configuration).downloadInputRecordGroupWithChildren(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InputRecordGroupsApiListInputRecordGroupWithChildrensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listInputRecordGroupWithChildrens(requestParameters: InputRecordGroupsApiListInputRecordGroupWithChildrensRequest = {}, options?: RawAxiosRequestConfig) {
        return InputRecordGroupsApiFp(this.configuration).listInputRecordGroupWithChildrens(requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InputRecordGroupsApiPartialUpdateInputRecordGroupWithChildrenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public partialUpdateInputRecordGroupWithChildren(requestParameters: InputRecordGroupsApiPartialUpdateInputRecordGroupWithChildrenRequest, options?: RawAxiosRequestConfig) {
        return InputRecordGroupsApiFp(this.configuration).partialUpdateInputRecordGroupWithChildren(requestParameters.id, requestParameters.partialInputRecordGroupWithChildren, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InputRecordGroupsApiRetrieveInputRecordGroupWithChildrenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveInputRecordGroupWithChildren(requestParameters: InputRecordGroupsApiRetrieveInputRecordGroupWithChildrenRequest, options?: RawAxiosRequestConfig) {
        return InputRecordGroupsApiFp(this.configuration).retrieveInputRecordGroupWithChildren(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retry the export of the tms order.
     * @param {InputRecordGroupsApiRetryInputRecordGroupWithChildrenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retryInputRecordGroupWithChildren(requestParameters: InputRecordGroupsApiRetryInputRecordGroupWithChildrenRequest, options?: RawAxiosRequestConfig) {
        return InputRecordGroupsApiFp(this.configuration).retryInputRecordGroupWithChildren(requestParameters.id, requestParameters.inputRecordGroupWithChildren, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InputRecordGroupsApiUpdateInputRecordGroupWithChildrenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateInputRecordGroupWithChildren(requestParameters: InputRecordGroupsApiUpdateInputRecordGroupWithChildrenRequest, options?: RawAxiosRequestConfig) {
        return InputRecordGroupsApiFp(this.configuration).updateInputRecordGroupWithChildren(requestParameters.id, requestParameters.inputRecordGroupWithChildren, options).then((request) => request(this.axios, this.basePath));
    }
}

